import tsfont from '../../tsfont.json';
import { IfontBuilderIconConfig } from 'models/IfontBuilderIconConfig';

export function iconIsAvailable(icon: string) {
  const availableHeliosDictionaryIcons = (
    tsfont.icons.node_modules as IfontBuilderIconConfig
  )['@trustedshops/helios-style-dictionary/assets/icons'];

  const availableHeliosIcons = (tsfont.icons.src as IfontBuilderIconConfig)[
    'assets/icons'
  ];

  return (
    availableHeliosIcons.includes(icon) ||
    availableHeliosDictionaryIcons.includes(icon)
  );
}
